import React, { Children, cloneElement } from 'react'

const TabGroup = ({activeTab, onChange, children}) => {
  const childrenWithProps = () => {
    return Children.map(children, (child, idx) => {
      return cloneElement(child, {
        key: idx,
        activeTab,
        onClick: onChange
      })
    })
  }

  return (
    <div className='tab-groups'>
      { childrenWithProps() }
    </div>
  )
}

export default TabGroup
